export const THUMBNAIL_STATE_PATH = 'previewThumbnail';

export { default } from './previewThumbnailReducer';
